import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useDispatch } from "react-redux";
import { getAgent } from "../features/agent/agentSlice";
import { editConfiguration } from "../features/configuration/configurationSlice";
import { llmModelOptions, providerLabels } from "../constants/model.constants";
import { toast } from "react-toastify";

function AgentDetail() {
  const { uuid } = useParams();
  const dispatch = useDispatch();

  const [agent, setAgent] = useState(null);
  const [loading, setLoading] = useState(true);

  const [form, setForm] = useState({
    agentPrompt: "",
    llmModel: "",
    llmProvider: "",
    meetingPrompt: "",
    isDefaultPromptActive: false,
  });

  useEffect(() => {
    dispatch(getAgent(uuid))
      .unwrap()
      .then((res) => {
        const data = res?.data || res;

        setAgent(data);

        setForm({
          agentPrompt: data?.chatConfiguration?.agentPrompt || "",
          llmModel: data?.chatConfiguration?.llmModel || "",
          llmProvider: data?.chatConfiguration?.llmProvider || "openai",
          meetingPrompt: data?.chatConfiguration?.meetingPrompt || "",
          isDefaultPromptActive:
            data?.chatConfiguration?.isDefaultPromptActive || false,
        });

        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, [uuid, dispatch]);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleProviderChange = (e) => {
    setForm({
      ...form,
      llmProvider: e.target.value,
      llmModel: "",
    });
  };

  const handleUpdate = async () => {
    try {
      await dispatch(
        editConfiguration({
          uuid: agent?.chatConfiguration?.uuid,
          data: {
            agentPrompt: form.agentPrompt,
            llmModel: form.llmModel,
            llmProvider: form.llmProvider,
            meetingPrompt: form.meetingPrompt,
            isDefaultPromptActive: form.isDefaultPromptActive,
          },
        }),
      ).unwrap();

      toast.success("Configuration updated successfully");
    } catch (error) {
      console.error(error);
      toast.error(error?.message || "Failed to update configuration");
    }
  };

  const handleCheckboxChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.checked,
    });
  };
  if (loading) return <div className="p-4">Loading...</div>;
  if (!agent) return <div className="p-4">Agent not found</div>;

  return (
    <div className="content mt-6">
      <div className="container-fluid">
        <h3 className="mb-4 fw-bold">Agent Details</h3>

        <div className="card p-4 mb-4">
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Agent Name</label>
              <input className="form-control" value={agent.name} disabled />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Account Name</label>
              <input
                className="form-control"
                value={agent.accountId?.name}
                disabled
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">User Name</label>
              <input
                className="form-control"
                value={agent?.userId?.email}
                disabled
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Created At</label>
              <input
                className="form-control"
                value={moment(agent.createdAt).format("LLL")}
                disabled
              />
            </div>
          </div>
        </div>

        <div className="card p-4 mb-4">
          <h5 className="mb-3">Chat Configuration</h5>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">LLM Provider</label>
              <select
                className="form-select"
                name="llmProvider"
                value={form.llmProvider}
                onChange={handleProviderChange}
              >
                <option value="">Select Provider</option>
                {Object.keys(llmModelOptions).map((provider) => (
                  <option key={provider} value={provider}>
                    {providerLabels[provider] || provider}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">LLM Model</label>
              <select
                className="form-select"
                name="llmModel"
                value={form.llmModel}
                onChange={handleChange}
                disabled={!form.llmProvider}
              >
                <option value="">Select Model</option>
                {(llmModelOptions[form.llmProvider] || []).map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-12 mb-3">
              <label className="form-label">Agent Prompt</label>
              <textarea
                className="form-control"
                name="agentPrompt"
                rows={10}
                value={form.agentPrompt}
                onChange={handleChange}
                placeholder="Enter agent prompt"
              />
            </div>

            <div className="col-md-12 mb-3">
              <label className="form-label">Meeting Prompt</label>
              <textarea
                className="form-control"
                name="meetingPrompt"
                rows={10}
                value={form.meetingPrompt}
                onChange={handleChange}
                placeholder="Enter meeting prompt"
              />
            </div>
          </div>
          <div className="col-md-12 mb-3 ps-4">
            <div className="form-check d-flex align-items-center gap-5">
              <input
                type="checkbox"
                className="form-check-input"
                id="isDefaultPromptActive"
                name="isDefaultPromptActive"
                checked={form.isDefaultPromptActive}
                onChange={handleCheckboxChange}
              />
              <label
                className="form-check-label"
                htmlFor="isDefaultPromptActive"
              >
                Use Default Meeting Prompt
              </label>
            </div>
          </div>
          <div className="d-flex justify-content-end gap-2">
            <button className="btn btn-primary" onClick={handleUpdate}>
              Update Config
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgentDetail;
